// extracted by mini-css-extract-plugin
export default {"controls":"_1N_aa","monthControls":"_3gadt","monthButton":"Var4D","back":"_2_c2i","month":"_3raOT","loading":"_1kgli","next":"Ya27V","days":"_17FTP"};